import { createPortal } from 'react-dom'

const BankLinkageProgress = ({ status, error, onDismiss }) => (
  <>
      {!status && error && createPortal(
        <div className='fixed inset-0 z-[2000] flex items-center justify-center bg-gray-900/30 p-4'>
          <div role='alertdialog' aria-modal='true' aria-labelledby='linkage-error-title' aria-describedby='linkage-error-description' className='w-full max-w-md rounded-3xl bg-white p-8 shadow-2xl'>
            <h2 id='linkage-error-title' className='font-semibold'>No se pudo completar la conciliación</h2>
            <p id='linkage-error-description' className='my-4 text-sm'>{error}</p>
            <button autoFocus type='button' onClick={onDismiss} className='rounded-full bg-accent2 px-4 py-2 text-white'>Entendido</button>
          </div>
        </div>, document.body
      )}
      {status && createPortal(
        <div className='fixed inset-0 z-[2000] flex items-center justify-center bg-gray-900/30 p-4 backdrop-blur-sm' role='status' aria-live='polite' aria-busy='true'>
          <div className='flex w-full max-w-sm flex-col items-center rounded-3xl border border-gray-100 bg-white px-8 py-9 text-center font-sans shadow-2xl'>
            <div className='mb-5 flex h-16 w-16 items-center justify-center rounded-full bg-accent2/10' aria-hidden='true'>
              <svg className='h-8 w-8 animate-spin text-accent2 motion-reduce:animate-none' viewBox='0 0 32 32' fill='none'>
                <circle cx='16' cy='16' r='13' stroke='currentColor' strokeWidth='3' className='opacity-20' />
                <path d='M16 3a13 13 0 0 1 13 13' stroke='currentColor' strokeWidth='3' strokeLinecap='round' />
              </svg>
            </div>
            <p className='text-base font-semibold leading-6 text-gray-800'>Estamos preparando tu vinculación</p>
            <p className='mt-2 text-sm font-normal leading-6 text-gray-500'>{status}</p>
            <span className='mt-5 rounded-full bg-gray-50 px-3 py-1 text-xs text-gray-500'>Esto puede tomar unos momentos</span>
          </div>
        </div>, document.body
      )}
  </>
)

export default BankLinkageProgress
